var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("DropdownFilter", {
    attrs: {
      withoutLoading: "",
      placeholder: "Select currency",
      customMultiStyleParent: _vm.getcontainerStyle,
      value: _vm.mappedValue,
      multiple: false,
      options: _vm.currencyOptions,
    },
    on: { input: _vm.handleInput },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }